import { Notification } from 'element-ui';
import errorsMap from './errors.map';

export const errorHandlerInterceptor = (error) => {
  const errorMessage = errorsMap[error.response ? error.response.status : 500];
  Notification.error({
    title: 'Error',
    message: errorMessage,
  });

  Promise.reject(error);
};
